import { Types, types } from '../types'

export const loginRequest = (params) => {
  return {
    type: types.LOGIN_REQUEST,
    params: params,
  }
}

export const registerRequest = (params) => {
  return {
    type: types.REGISTER_REQUEST,
    params: params,
  }
}

export const registerReset = () => {
  return {
    type: types.REGISTER_USER_RESET_PROPS,

  }
}

export const loginReset = () => {
  return {
    type: types.LOGIN_USER_RESET_PROPS,

  }
}

export const verificationReset = () => {
  return {
    type: types.SEND_VERIFICTION_RESET,

  }
}






export const sendPassword = (params) => {
  return {
    type: types.SET_PASSWORD_REQUEST,
    params: params,
  }
}

export const sendVerifictionCode = (params) => {
  return {
    type: types.SEND_VERIFICTION_REQUEST,
    params: params,
  }
}

export const registerSendVerifictionCode = (params) => {
  return {
    type: types.REGISTER_SEND_VERIFICTION_REQUEST,
    params: params,
  }
}

export const registerSendVerifictionCodeReset = (params) => {
  return {
    type: types.REGISTER_SEND_VERIFICTION_RESET_PROPS,
    params: params,
  }
}

export const loginPassword = (params) => {
  return {
    type: types.LOGIN_PASSWORD_REQUEST,
    params: params,
  }
}




export const resetProps = () => {
  return {
    type: types.USER_RESET_PROPS,
  }
}

export const getAllCompany = (params) => {
  return {
    type: types.GET_ALL_COMPANY_REQUEST,
    params: params,

  }
}


export const addComponyAction = (params) => {
  return {
    type: types.ADD_COMPANY_REQUEST,
    params: params,

  }
}


export const setUserEmail = (params) => {
  return {
    type: 'userEmail',
    payload: params
  }
}


export const forgetPasswordAction = (params) => {
  return {
    type: types.FORGOT_PASSWORD_REQUEST,
    params: params,
  }
}


export const getSessionIdAction = () => {
  return {
    type: types.GET_SESSION_ID_REQUEST,
  }
}


export const setUserInfo = (params) => {
  return {
    type: Types.SET_USER_INFO, params
  }
}
